export const removeNullValuesFromHintsObject = <T extends Record<string, any>>(obj: T) => {
  const newObj: T = { ...obj };
  for (const key in obj) {
    const objectKey = key as keyof T;
    const value = obj[objectKey];
    if (Array.isArray(value)) {
      const filterdValue = value.filter(
        (value: T[keyof T][number]) => value !== null,
      ) as T[keyof T];
      newObj[objectKey] = filterdValue;
    }
  }
  return newObj;
};
